var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h80v80H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    stroke: "#54B8F9",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M65.167 40a25.167 25.167 0 0 0-14.45-22.771",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.167 40c0-6.401-2.439-12.562-6.82-17.228",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.167 40c0-3.172-.6-6.315-1.767-9.265",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.667 40v-.149",
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    stroke: "#54B8F9",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M27.417 18.205a25.166 25.166 0 0 0-12.495 23.9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.417 18.205a25.166 25.166 0 0 0-11.51 14.521",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.417 18.205a25.167 25.167 0 0 0-7.14 6.163",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 19.504a20.5 20.5 0 0 0-.129.075",
    strokeWidth: 6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    stroke: "#54B8F9",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M27.418 61.795a25.166 25.166 0 0 0 26.946-1.13",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.418 61.795a25.166 25.166 0 0 0 18.33 2.707",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.418 61.795a25.164 25.164 0 0 0 8.907 3.102",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.168 60.496c.043.025.085.05.129.074",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.334 13.333)",
    d: "M0 0h53.333v53.333H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-120 37.183 29.484)",
    d: "M0 0h53.333v53.333H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(120 29.484 37.182)",
    d: "M0 0h53.333v53.333H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("image", {
    id: "e",
    width: 1,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.62273701948ba579e795afdc91e0bdd4.svg";
export { ForwardRef as ReactComponent };